// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"b1aa800c","752":"6e4fb514"}[chunkId] + ".chunk.css";
};